AGADash.BarsAndStack = (function () {

    var colorMap = {
        "a1": "#67B7DC",
        "a2": "#fdd400",
        "a3": "#FF6600",
        "a4": "#B0DE09",
        "a5": "#2F4074"
    };
    var axisIdList = ["a1", "a2", "a3", "a4", "a5"];

    function getAxisId(gType) {
        if (gType.indexOf("5") > 0)
            return { "id": axisIdList[4], "position": "left", "axisThickness": 2, "gridAlpha": 0, "axisAlpha": 1, "offset": 100 };
        if (gType.indexOf("4") > 0)
            return { "id": axisIdList[3], "position": "right", "axisThickness": 2, "gridAlpha": 0, "axisAlpha": 1, "offset": 50 };
        if (gType.indexOf("3") > 0)
            return { "id": axisIdList[2], "position": "left", "axisThickness": 2, "gridAlpha": 0, "axisAlpha": 1, "offset": 50 };
        if (gType.indexOf("2") > 0)
            return { "id": axisIdList[1], "position": "right", "axisThickness": 2, "gridAlpha": 0, "axisAlpha": 1 };
        return { "id": axisIdList[0], "position": "left", "axisThickness": 2, "gridAlpha": 0, "axisAlpha": 1 };
    };

    function addValueAxis(list, item) {
        for (var i = 0; i < list.length; i++) {
            if (list[i].id === item.id)
                return;
        }
        list.push(item);
    };

    function applyColors(graphs, axis) {
        if (graphs.length === 1 || axis.length === 1)
            return;

        // cores dos axis
        var i;
        for (i = 0; i < axis.length; i++) {
            axis[i]["axisColor"] = colorMap[axis[i].id];
        }

        for (i = 0; i < graphs.length; i++) {
            var g = graphs[i];
            g["lineColor"] = colorMap[g["valueAxis"]];

        }
    };

    var buildDataset = function (data) {
        var dataset = [];
        var keyIgnored = [];
        var facts = [];
        var i;
        for (i = 0; i < data.Facts.length; i++) {
            var n = data.Facts[i].split('=')[0];
            keyIgnored.push(n);
            facts.push(n);
        }

        var titleFmt = AGADash.Common.getFormatInfo(data, data.Dimensions[0]);
        keyIgnored.push(data.Dimensions[0]);
        for (i = 0; i < data.Values.length; i++) {
            var record = AGADash.Common.getRecord(data, i);
            var row = {};
            row["TITLE"] = AGADash.Common.Formatter.formatByInfo(titleFmt, record[data.Dimensions[0]]);
            for (var f = 0; f < facts.length; f++) {
                row[facts[f]] = record[facts[f]];
            }
            row["KEY"] = AGADash.Common.getDetailKey(data, i, keyIgnored);
            dataset.push(row);
        }
        return dataset;
    };


    var itemClickHandler = function (e) {
        // Detalhes
        var key = e.item.dataContext["KEY"];
        if (key) {
            AGADash.Panel.loadDetails(e.chart.div, key);
        }
    };

    var invokeBeforeLoad = function (beforeLoadArgs, def) {
        // Executar evento beforeload
        AGADash.Events.invoke("beforeload", beforeLoadArgs.uid, function () {
            return $.extend({ "config": def }, beforeLoadArgs);
        });
    }

    var invokeAfterLoad = function(afterLoadArgs, chart) {
        // Evento afterload
        AGADash.Events.invoke("afterload", afterLoadArgs.uid, function () {
           return $.extend({"chart": chart}, afterLoadArgs);
        });
    };
    
    return {

        render: function (body, data, stacked) {

            $(body).addClass("dash-bars-placeholder");

            // Build data set
            var dataset = buildDataset(data);

            var placeHolder = $(body).attr("id");

            var graphs = [];
            var valueAxisList = [];

            var defaultType = stacked ? "stack" : "column";
            var i;
            var labelFunction = function (value, valueText, vl) {
                return AGADash.Common.Formatter.formatByInfo(vl.bennerDataInfo, value);
            };
            var balloonFunction = function (gdi, gr) {
                return gr.title + ": <b>" + AGADash.Common.Formatter.formatByInfo(gr.bennerDataInfo, gdi.values.value) + "</b>";
            };

            for (i = 0; i < data.Facts.length; i++) {
                var parts = data.Facts[i].split("=");
                var name = parts[0];
                var gType = (parts.length > 1) ? gType = parts[1].toLowerCase() : defaultType;

                if (gType.indexOf("linha") === 0) {
                    gType = gType.replace("linha", "line");
                }

                var dataInfo = AGADash.Common.getFormatInfo(data, name);

                var va = getAxisId(gType);
                addValueAxis(valueAxisList, va);

                if (!va.bennerDataInfo) {
                    va.bennerDataInfo = dataInfo;
                    va.labelFunction = labelFunction;
                }

                var g = {
                    "valueAxis": va.id,
                    "balloonFunction": balloonFunction,
                    "title": dataInfo.Title,
                    "fillAlphas": 0.8,
                    "lineAlpha": 0.2,
                    "precision": AGADash.Common.Formatter.getPrecision(dataInfo.Format),
                    "valueField": name,
                    "bennerDataInfo": dataInfo
                };

                if (gType.indexOf("line") === 0) {
                    gType = "line";
                    g["fillAlphas"] = 0.0;
                    g["lineAlpha"] = 1;
                    g["bullet"] = "round";
                    g["lineThickness"] = 3;
                    g["bulletSize"] = 7;
                    g["bulletBorderAlpha"] = 1;
                    g["bulletColor"] = "#FFFFFF";
                    g["useLineColorForBulletBorder"] = true;
                    g["bulletBorderThickness"] = 3;
                }
                else if (gType.indexOf("preencher") === 0 || gType.indexOf("stack") === 0)
                    gType = "line";
                else {
                    gType = "column";
                }

                g["type"] = gType;
                graphs.push(g);
            }

            if (stacked) {
                for (i = 0; i < valueAxisList.length; i++) {
                    valueAxisList[i]["stackType"] = "regular";
                }
            }

            applyColors(graphs, valueAxisList);

            var def = {
                "language": "pt",
                "type": "serial",
                "theme": "light",
                "dataProvider": dataset,
                "valueAxes": valueAxisList,
                "gridAboveGraphs": true,
                "startDuration": 0.2,
                "graphs": graphs,
                "chartCursor": {
                    "categoryBalloonEnabled": true,
                    "categoryBalloonAlpha": 1,
                    "categoryBalloonColor": "#0D8ECF",
                    "cursorAlpha": 0,
                    "zoomable": false
                },
                "categoryField": 'TITLE',
                "categoryAxis": {
                    "gridPosition": "start",
                    "gridAlpha": 0,
                    "tickPosition": "start",
                    "tickLength": 20,
                    "labelRotation": 45
                },
                "decimalSeparator": ",",
                "thousandsSeparator": ".",
                "export": AGADash.Charts.getExportSettings()

            };

            // legendas
            var legend = AGADash.Charts.getLegend(data);
            if (legend) {
                def["legend"] = legend;
            }

            var baseEventArgument = AGADash.Events.getBaseEventArguments(body);
            invokeBeforeLoad(baseEventArgument, def);
            
            var chart = AmCharts.makeChart(placeHolder, def);
            
            invokeAfterLoad(baseEventArgument, chart);

            chart.addListener("clickGraphItem", itemClickHandler);
        }
    };

})();